module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av302-1b031e33bb4068a02940679f7228ddc1.jpg";